export default "__VITE_ASSET__B1J__eYi__$_?no-inline__"